var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-email-page" },
    [
      _c(
        "div",
        { staticClass: "document-email-page__header" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.$l10n.__("Emails")))]),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.send_email"),
              type: "primary",
              size: "medium"
            },
            on: { click: _vm.checkIsEmailSetUp }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("timeline", {
        attrs: {
          linkedtype: _vm.linkedtype,
          linkedid: parseInt(_vm.linkedid),
          overviewType: _vm.linkedtype,
          isDocument: ""
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }